import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Conferma Indirizzo Email',
  [OnboardingStep.StoreDetails]: 'Dettagli del punto vendita',
  [OnboardingStep.BusinessInfo]: 'Dettagli aziendali',
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Aggiungi i dettagli del negozio',
  [OnboardingStep.PersonalInfo]: 'Aggiungi le tue informazioni personali',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: 'Informazioni personali del titolare',
  owner_personal_info_gmbh: 'Informazioni personali del titolare / amministratore delegato',
  [OnboardingStep.ShippingInfo]: 'Aggiungi le informazioni di consegna',
  [OnboardingStep.BankInfo]: 'Aggiungi coordinate bancarie per i pagamenti',
  [OnboardingStep.TaxInfo]: 'La tua azienda è registrata ai fini IVA?',
  [OnboardingStep.BusinessDocs]: 'Documento di prova aziendale',
  [OnboardingStep.PersonalDocs]: "Documento di prova d'identità",
  [OnboardingStep.InfoSubmission]: 'Ricevi pagamenti',
  confirm_info_gateway: 'Ricevi pagamenti – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Informazioni di pagamento',
  [OnboardingStep.Subscription]: 'Abbonamento',
  [OnboardingStep.MobileApp]: 'App mobile',
  [OnboardingStep.DeliveryStructure]: 'Struttura di consegna',
  [OnboardingStep.Contract]: 'Contratto',
  [OnboardingStep.ContractPayment]: 'Pagamento contratto',
  [OnboardingStep.Documents]: 'Carica documenti',
  [OnboardingStep.PromoCode]: 'Codice promo',
};
